import { I18n } from 'react-redux-i18n';

const PERFORMANCE_CLIENT_IDS = [1, 499];
const V2_CLIENT_IDS: number[] = [1, 499];
const DISTRIBUTION_ANALYSIS_CLIENT_IDS: number[] = [1];
const SPIRIT_GEOGRAPHY_FILTER_CLIENT_IDS: number[] = [1, 499];

export const showV2Experience = (clientId: number | null): boolean => {
  return clientId !== null && V2_CLIENT_IDS.includes(clientId);
};

export const showDistributionAnalysis = (clientId: number | null): boolean => {
  return (
    clientId !== null && DISTRIBUTION_ANALYSIS_CLIENT_IDS.includes(clientId)
  );
};

export const showPerformance = (clientId: number | null) => {
  return clientId !== null && PERFORMANCE_CLIENT_IDS.includes(clientId);
};

export const showSpiritGeographyFilters = (
  clientId: number | null
): boolean => {
  return (
    clientId !== null && SPIRIT_GEOGRAPHY_FILTER_CLIENT_IDS.includes(clientId)
  );
};

export const showDistributionVintage = (tags_names: string[]) => {
  return !tags_names.includes('Champagne') && !tags_names.includes('Spirit');
};

export const showDistributionKPIConsoRate = (tags_names: string[]) => {
  return !tags_names.includes('Champagne') && !tags_names.includes('Spirit');
};

export const showDistributionKPIBestVintage = (tags_names: string[]) => {
  return (
    !tags_names.includes('Champagne') &&
    !tags_names.includes('GVM') &&
    !tags_names.includes('Spirit')
  );
};

export const showDistributionKPIOldDN = (tags_names: string[]) => {
  return (
    !tags_names.includes('Champagne') &&
    !tags_names.includes('GVM') &&
    !tags_names.includes('Spirit')
  );
};

export const showDistributionKPDNBtg = (tags_names: string[]) => {
  return (
    tags_names.includes('Champagne') ||
    tags_names.includes('GVM') ||
    tags_names.includes('Spirit')
  );
};

export const showNCBars = (tags_names: string[]) => {
  return tags_names.includes('Spirit');
};

export const isSpiritOnly = (tags_names: string[]) => {
  return tags_names.includes('Spirit') && tags_names.length === 1;
};

export const getTravelPillOptionsForDefault = (tags_names: string[]) => {
  if (tags_names.includes('Spirit')) {
    return ['all', 'Spirit', 'Champagne'];
  }
  return ['all', 'Bordeaux', 'Champagne', 'GVM'];
};

export const getTravelPillOptions = (tags_names: string[]) => {
  const all_options = [
    {
      label: I18n.t('travel.wineCategoryOptions.all'),
      value: 'all'
    },
    {
      label: I18n.t('travel.wineCategoryOptions.spirit'),
      value: 'Spirit'
    },
    {
      label: I18n.t('travel.wineCategoryOptions.bordeaux'),
      value: 'Bordeaux'
    },
    {
      label: I18n.t('travel.wineCategoryOptions.champagne'),
      value: 'Champagne'
    },
    {
      label: I18n.t('travel.wineCategoryOptions.worldWines'),
      value: 'GVM'
    }
  ];
  const TravelPillDefaultOptions = getTravelPillOptionsForDefault(tags_names);
  return all_options.filter((option) =>
    TravelPillDefaultOptions.includes(option.value)
  );
};
